import { render, staticRenderFns } from "./ImportStatus.vue?vue&type=template&id=3fa477d9&scoped=true&"
import script from "./ImportStatus.vue?vue&type=script&lang=ts&"
export * from "./ImportStatus.vue?vue&type=script&lang=ts&"
import style0 from "./ImportStatus.vue?vue&type=style&index=0&id=3fa477d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa477d9",
  null
  
)

export default component.exports